import React from 'react';
import { useNavigate } from 'react-router-dom';

const HomePage = () => {
  const navigate = useNavigate();

  const startQuiz = () => {
    navigate('/quiz');
  };

  return (
    <div className="homepage">
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 data-testid="hero-headline">
              🐾 Find the Perfect Food for Your Dog in 2 Minutes
            </h1>
            <p className="hero-subtitle" data-testid="hero-subtitle">
              Answer a few quick questions and get a vet-curated recommendation
              of 3 foods tailored to your dog's age, weight, and needs.
            </p>
            <button 
              className="cta-button" 
              data-testid="hero-cta-button"
              onClick={startQuiz}
            >
              Find the perfect food for your dog now
            </button>
          </div>
        </div>
      </section>

      <section className="second-cta-section" data-testid="second-cta-section">
        <div className="container">
          <div className="cta-content text-center">
            <h2 data-testid="second-headline">
              Stop Guessing: Find the Perfect Fuel for Your Dog
            </h2>
            <p className="cta-subtitle" data-testid="second-subtitle">
              Get a precise recommendation based on your dog's breed, age, 
              activity level, and specific health needs.
            </p>
            <button 
              className="cta-button" 
              data-testid="second-cta-button"
              onClick={startQuiz}
            >
              Find the perfect food for your dog now
            </button>
          </div>
        </div>
      </section>

      <section className="section-sm">
        <div className="container">
          <div className="disclaimer">
            <h4>Important Notice</h4>
            <p>
              These recommendations are for general informational purposes only and 
              do not replace professional veterinary advice. Always consult your 
              veterinarian for personalized care.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;